// removed by extract-text-webpack-plugin
module.exports = {"callComponent":"callComponent__3nFPz","title":"title__2a3qB","name":"name__1mNZk","descr":"descr__ndGJF","avatar":"avatar__336Li","btnArea":"btnArea__2KEHh","btn":"btn__gazae","btnText":"btnText__1Qpxv","btnImg":"btnImg__3nxQe"};


//////////////////
// WEBPACK FOOTER
// ./components/communication/call/style.scss
// module id = SmHd
// module chunks = 27